export const getConnectionStatusColor = (status) => {
  if (status === 'ACTIVE') return 'success'
  else if (status === 'JUST REGISTERED') return 'primary'
  else if (status === 'IDLE') return 'warning'
  else if (status === 'OFFLINE') return 'error'
  else if (status === 'SIGNAL LOST') return 'default'
}